/** খরচ, ক্যাশবুক ও টাকার লেনদেন। */
export const accounting = {
    expenses: {
        title: "খরচ",
        description: "অ্যাকাউন্ট থেকে খরচ করা টাকা — ভাড়া, বিল, বেতন, সরঞ্জাম। প্রতিটি খরচ একটি অ্যাকাউন্ট থেকে যায়।",
        record: "খরচ লিখুন",
        categories: "খাতসমূহ",
        empty: "এই সময়ে কোনো খরচ নেই।",
        emptyBody: "ভাড়া, বিদ্যুৎ, বেতন ও অন্যান্য খরচ লিখুন — লাভ-ক্ষতি ও ক্যাশবুকে দেখা যাবে।",
        voided: "বাতিল",
        voidOf: "বাতিল এন্ট্রি",
        void: "বাতিল",
        voidReason: "খরচটি কেন বাতিল করছেন?",
        voidDone: "খরচ বাতিল হয়েছে; টাকা অ্যাকাউন্টে ফিরেছে।",
        saved: "খরচ {{number}} লেখা হয়েছে।",
        headOffice: "প্রধান কার্যালয়",
        receipt: "রসিদ",
        viewReceipt: "রসিদ দেখুন",
        columns: {
            number: "নং",
            date: "তারিখ",
            category: "খাত",
            location: "শাখা",
            account: "যে অ্যাকাউন্ট থেকে",
            description: "বিবরণ",
            amount: "পরিমাণ",
        },
        filters: {
            from: "শুরু",
            to: "শেষ",
            location: "শাখা",
            category: "খাত",
            any: "সব",
        },
        form: {
            title: "খরচ লিখুন",
            category: "খাত",
            location: "শাখা",
            account: "যে অ্যাকাউন্ট থেকে",
            amount: "পরিমাণ",
            date: "তারিখ",
            description: "বিবরণ",
            receipt: "রসিদের ছবি (ঐচ্ছিক)",
            uploading: "আপলোড হচ্ছে…",
            save: "খরচ লিখুন",
            noCategories: "আগে একটি খাত যোগ করুন।",
        },
        categoriesSheet: {
            title: "খরচের খাত",
            name: "নতুন খাত",
            add: "যোগ",
            archive: "আর্কাইভ",
            restore: "ফিরিয়ে আনুন",
            archived: "আর্কাইভ করা",
            empty: "এখনো কোনো খাত নেই। ভাড়া, বিদ্যুৎ, বেতন… যোগ করুন",
            saved: "খাত সংরক্ষিত।",
        },
    },
    cashbook: {
        title: "ক্যাশবুক",
        description: "শাখার ক্যাশ ড্রয়ার ও ক্যাশ বাক্সে প্রতিটি টাকার আসা-যাওয়া, প্রতিদিন শেষের ব্যালেন্সসহ।",
        location: "শাখা",
        from: "শুরু",
        to: "শেষ",
        pickLocation: "ক্যাশবুক দেখতে একটি শাখা বেছে নিন।",
        noAccounts: "এই শাখায় এখনো কোনো ক্যাশ ড্রয়ার বা ক্যাশ বাক্স নেই।",
        opening: "প্রারম্ভিক ব্যালেন্স",
        in: "টাকা এসেছে",
        out: "টাকা গেছে",
        closing: "সমাপনী ব্যালেন্স",
        days: "দিনভিত্তিক",
        entries: "এন্ট্রি",
        truncated: "প্রথম {{count}}টি এন্ট্রি দেখানো হলো; দিনের মোটে সব আছে।",
        empty: "এই সময়ে কোনো লেনদেন নেই।",
        columns: {
            date: "তারিখ",
            time: "সময়",
            kind: "কী",
            account: "অ্যাকাউন্ট",
            note: "বিবরণ",
            in: "এসেছে",
            out: "গেছে",
            balance: "ব্যালেন্স",
            opening: "শুরু",
            closing: "শেষ",
        },
    },
    kinds: {
        sale_receipt: "বিক্রির পেমেন্ট",
        refund: "ফেরত",
        other_in: "টাকা এসেছে",
        other_out: "টাকা গেছে",
        transfer_in: "স্থানান্তর (এসেছে)",
        transfer_out: "স্থানান্তর (গেছে)",
        cod_payout: "কুরিয়ার পেমেন্ট",
        courier_charge: "কুরিয়ার চার্জ",
        expense: "খরচ",
        supplier_payment: "সাপ্লায়ার পেমেন্ট",
        customer_payment: "কাস্টমারের বকেয়া পরিশোধ",
        cash_in: "ক্যাশ ইন",
        cash_out: "ক্যাশ আউট",
        shift_variance: "শিফটে বেশি / কম",
    },
};
//# sourceMappingURL=accounting.js.map